import * as ngCore from '@angular/core'
import * as fa from '@fortawesome/angular-fontawesome'
import * as faSvg from '@fortawesome/free-solid-svg-icons'

interface IconInfo {
  readonly icon: faSvg.IconDefinition
  readonly color: string
}

/**
 * Icon representing the given MIME type
 */
@ngCore.Component({
  imports: [fa.FaIconComponent],
  selector: 'atn-ds-file-icon',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * MIME type used to determine the appropriate icon
   */
  public mimeTypeSg = ngCore.input<string>(undefined, {
    alias: 'mimeType',
  })

  /**
   * Determines what icon and color should be displayed based on the
   * {@link mimeTypeSg}
   */
  public infoSg = ngCore.computed<IconInfo>((mimeType = this.mimeTypeSg()) => {
    const defaultInfo: IconInfo = {
      color: '#616161',
      icon: faSvg.faFile,
    }

    // Default file icon
    if (mimeType === undefined) {
      return defaultInfo
    }

    // PDF files
    if (mimeType === 'application/pdf') {
      return { color: '#d32f2f', icon: faSvg.faFilePdf }
    }

    // Excel files
    if (
      mimeType === 'application/vnd.ms-excel' ||
      mimeType ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      mimeType === 'text/csv'
    ) {
      return { color: '#388e3c', icon: faSvg.faFileExcel }
    }

    // Word files
    if (
      mimeType === 'application/msword' ||
      mimeType ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      return { color: '#1976d2', icon: faSvg.faFileWord }
    }

    // PowerPoint files
    if (
      mimeType === 'application/vnd.ms-powerpoint' ||
      mimeType ===
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ) {
      return { color: '#f57c00', icon: faSvg.faFilePowerpoint }
    }

    // Image files
    if (mimeType.startsWith('image/')) {
      return { color: '#7b1fa2', icon: faSvg.faFileImage }
    }

    // Video files
    if (mimeType.startsWith('video/')) {
      return { color: '#c62828', icon: faSvg.faFileVideo }
    }

    // Audio files
    if (mimeType.startsWith('audio/')) {
      return { color: '#00796b', icon: faSvg.faFileAudio }
    }

    // Archive files
    if (
      mimeType === 'application/zip' ||
      mimeType === 'application/x-rar-compressed' ||
      mimeType === 'application/x-7z-compressed' ||
      mimeType === 'application/gzip'
    ) {
      return { color: '#5d4037', icon: faSvg.faFileArchive }
    }

    // Code files (optional for business context)
    if (
      mimeType === 'text/html' ||
      mimeType === 'text/css' ||
      mimeType === 'text/markdown' ||
      mimeType === 'text/x-markdown' ||
      mimeType === 'application/javascript' ||
      mimeType === 'application/json'
    ) {
      return { color: defaultInfo.color, icon: faSvg.faFileCode }
    }

    // Default file icon
    return defaultInfo
  })
}
